import UIComponent from "../ui/component";
import api from "../api";

export class Rates extends UIComponent {
    init() {
        if (!Number(this.available_region)) {
            this.includeComponents({
                regionPaymentModal:
                    'document@#regionPaymentModal',
            });
        }
        this.toggle?.on("change", () => this.handleToggleChange());
        if (!this.toggle) {
            this.addClass("active");
            this.updatePrices(true);
        }
        this.setInitialToggleState();

        this.findAll('a.subscription-button').forEach((button) => {
            button.addEventListener("click", (event) => this.handlePayment(event, button));
        });
    }

    setInitialToggleState() {
        if (this.toggle?.element) {
            this.toggle.element.checked = false;
            this.handleToggleChange();
        }
    }

    handleToggleChange() {
        const isYearly = this.toggle?.element.checked;
        if (isYearly) {
            this.addClass("active").addClass("active-live");
            this.updateSubscriptionLinks(true);
        } else {
            this.removeClass("active").removeClass("active-live");
            this.updateSubscriptionLinks(false);
        }
        this.updatePrices(isYearly);
    }

    updatePrices(isYearly) {
        this.findAll('.price-current').forEach(el => {
            el.textContent = isYearly ? el.dataset.priceYearly : el.dataset.priceMonthly;
        });
        this.findAll('.price-old').forEach(el => {
            // в годовом режиме зачёркиваем месячную цену, в месячном — полную цену до скидки за переход
            const oldPrice = isYearly ? el.dataset.priceOld : el.dataset.priceOldMonthly;
            if (oldPrice) {
                el.textContent = oldPrice;
                el.classList.remove('d-none');
            } else {
                el.classList.add('d-none');
            }
        });
        this.findAll('.min[data-cost-monthly]').forEach(el => {
            el.textContent = isYearly ? el.dataset.costYearly : el.dataset.costMonthly;
        });
    }

    updateSubscriptionLinks(addProlongation) {
        const buttons = this.findAll("a.subscription-button");

        buttons.forEach((button) => {
            let href = button.getAttribute("href");

            if (addProlongation) {
                href =
                    href +
                    (href.includes("?") ? "&" : "?") +
                    "prolongation=yearly";
            } else {
                href = href.replace(/[?&]prolongation=yearly/, "");
            }

            button.setAttribute("href", href);

            const isMonthlyAvailable =
                button.getAttribute("data-btn_monthly") === "1";
            const isYearlyAvailable =
                button.getAttribute("data-btn_yearly") === "1";

            const currentBtnTitle = button.querySelector('.current-btn-title');
            const buyBtnTitle = button.querySelector('.buy-btn-title');

            if (
                (addProlongation && isYearlyAvailable) ||
                (!addProlongation && isMonthlyAvailable)
            ) {
                button.classList.add("enable-btn");
                button.classList.remove("disable-btn");
                currentBtnTitle.classList.add("d-none");
                buyBtnTitle.classList.remove("d-none");
            } else {
                button.classList.add("disable-btn");
                button.classList.remove("enable-btn");
                buyBtnTitle.classList.add("d-none");
                currentBtnTitle.classList.remove("d-none");
            }
        });
    }

    handlePayment(event, button) {
        event?.preventDefault();

        const targetButton = button || event?.currentTarget;
        const href = targetButton?.getAttribute("href");

        if (!href) {
            return;
        }

        if (Number(this.available_region)) {
            window.location.href = href;
            return;
        }

        this.regionPaymentModal?.show(href);
    }
}
